<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<p class="dedit"><em class="italic">In memory of the Reverend John Morris Harrison, present at the liberation of Bergen-Belsen.</em></p>
<a id="page_vi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedi.vue?75e5b889